// App Imports
import Contact from '../Contact'

// Pages routes
const routes = {
  pagesContact: {
    path: '/contact',
    component: Contact,
    exact: true
  }
}

export default routes